import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";

/** Thumbnail addresses only; the backend sends nothing about whose they are. */
export type HomepageAvatars = {
  avatars: string[];
};

/**
 * The faces in the hero's participant field.
 *
 * Fetched rather than bundled, because who appears is a matter of each
 * person's consent and that can change after the site is built. The backend
 * returns whoever currently agrees, so withdrawing consent removes a face
 * without a deploy.
 */
export function useHomepageAvatars() {
  return useQuery({
    queryKey: ["homepageAvatars"],
    queryFn: (): Promise<HomepageAvatars> =>
      apiRequest("/marketing/avatars/", "GET", undefined, false),
    staleTime: 10 * 60 * 1000,
  });
}
